module.exports = __webpack_public_path__ + "img/route-point.69c788a2.svg";